module.exports = __webpack_public_path__ + "img/biao.d68f06ca.png";